import {ColorSchemeType} from 'platform/components';
import {match} from 'ts-pattern';

import {always} from 'ramda';

import {Nullish} from 'shared/web';

export const getMazdaStatusColorScheme = (status: string | Nullish) =>
  match<string | Nullish, ColorSchemeType>(status)
    .with('NEW', always('blue'))
    .with('PENDING', 'RETURNED', 'SUSPENDED', 'CANCELLED', 'CANCELED', always('orange'))
    .with('ACCEPTED', always('green'))
    .with('DENIED', always('red'))
    .otherwise(always('neutral'));
